import React, { createContext, ReactNode, useContext, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { GetWalletDetailsResponseData } from "../types/Wallet";
import { useWalletDetails } from "../swr/wallet";
import { useAuth } from "./AuthContext";

export interface StateContextProps {
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  ownerId: string;
  setOwnerId: React.Dispatch<React.SetStateAction<string>>;
  currentBalance: number;
  setCurrentBalance: React.Dispatch<React.SetStateAction<number>>;
  hasWallet: boolean | undefined;
  walletDetails: GetWalletDetailsResponseData | undefined
}

interface Props {
  children: ReactNode;
}

export const StateContext = createContext<StateContextProps>({
  currentBalance: 0,
  setCurrentBalance: () => {},
  email: "",
  setEmail: () => {},
  ownerId: "",
  setOwnerId: () => {},
  hasWallet: undefined,
  walletDetails: {} as GetWalletDetailsResponseData
});

export const ContextProvider = ({ children }: Props) => {
  const [currentBalance, setCurrentBalance] = useState<number>(0);
  const [email, setEmail] = useState("");
  const [ownerId, setOwnerId] = useState("");
  const { user } = useAuth();
  const { walletDetails, hasWallet } = useWalletDetails(!!user);

  return (
    <StateContext.Provider
      value={{
        email,
        setEmail,
        currentBalance,
        setCurrentBalance,
        ownerId,
        setOwnerId,
        hasWallet,
        walletDetails
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {children}
      </LocalizationProvider>
    </StateContext.Provider>
  );
};

export const useStateContext = (): StateContextProps =>
  useContext(StateContext);